<template>
  <div>
    
          <!-- Pages Cards -->
    <div class="pages-cards">
      <div class="container">
        <div class="row">

          <div class="col-lg-6 col-md-6">
            <div class="pcard" 
                  :style="'background:'+row.bgColor2+''">
              <div class="sub-title mb-2"
                  v-html="row.subTitle2"
                  :style="'color:'+row.subTitleColor2+' !important'">
              </div>
              <div class="bg-title mb-3"
                  v-html="row.title2"
                  :style="'color:'+row.titleColor2+' !important'">
              </div>
              <router-link v-if="row.button2" :to="row.redirect2"
                class="btn-square btn-square-white">{{ row.button2 }}
              </router-link>
            </div>
          </div>

          <div class="col-lg-6 col-md-6">
            <div class="pcard" 
                  :style="'background:'+row.bgColor3+''">
              <div class="sub-title mb-2"
                  v-html="row.subTitle3"
                  :style="'color:'+row.subTitleColor3+' !important'">
              </div>
              <div class="bg-title mb-3"
                  v-html="row.title3"
                  :style="'color:'+row.titleColor3+' !important'">
              </div>
              <router-link v-if="row.button3" :to="row.redirect3"
                class="btn-square btn-square-white">{{ row.button3 }}
              </router-link>
            </div>
          </div>


          <div class="col-lg-6 col-md-6">
            <div class="pcard" 
                  :style="'background:'+row.bgColor4+''">
              <div class="sub-title mb-2"
                  v-html="row.subTitle4"
                  :style="'color:'+row.subTitleColor4+' !important'">
              </div>
              <div class="bg-title mb-3"
                  v-html="row.title4"
                  :style="'color:'+row.titleColor4+' !important'">
              </div>
              <router-link v-if="row.button4" :to="row.redirect4"
                class="btn-square btn-square-white">{{ row.button4 }}
              </router-link>
            </div>
          </div>

          <div class="col-lg-6 col-md-6">
            <div class="pcard" 
                  :style="'background:'+row.bgColor5+''">
              <div class="sub-title white-color mb-2"
                  v-html="row.subTitle5"
                  :style="'color:'+row.subTitleColor5+' !important'">
              </div>
              <div class="bg-title mb-3"
                  v-html="row.title5"
                  :style="'color:'+row.titleColor5+' !important'">
              </div>
              <router-link v-if="row.button5" :to="row.redirect5"
                class="btn-square btn-square-white">{{ row.button5 }}
              </router-link>
            </div>
          </div>

        </div>
      </div>
    </div>
    <!-- Pages Cards -->

  </div>
</template>

<script>
export default {
  name: "Section2",
  props: ['row'],
  components: {},
  data() {
    return {
      pgLoading: true,
    };
  },
  created() {
      //
  },
  methods: {
    //
  },
};
</script>
